export const SINGLE_COURSE_PRICE = {
  energy: 1,
  money: 100,
};

export const LIMIT_SKILL = 5;
